export default () => ({
  popularCities: null,
  url_key: 'kiev',
  city_name: '',
  domain: 'ua'
})
